import {
  AttachmentWrapper,
  ContentTitle,
  InnerWrapper,
  WidgetHeader,
} from "../screens/InvoiceDetail/InvoiceDetail.styles"
import { IconButton } from "@mui/material"
import { handleDownload } from "../util/signedDownloads"
import PDFViewer from "../components/PDFViewer/PDFViewer"
import EmailViewer from "../components/EmailViewer/EmailViewer"
import Attachments from "../components/Attachments/Attachments"
// @ts-ignore
import DownloadIcon from "../icon/downloadIcon.svg?react"
import { useEmailAttachments } from "../hooks"

export interface Props {
  emailId: number
  emailSender: string
  emailSubject: string
  emailBody: string
  invoiceUrl: string
  renderInvoiceInline: boolean
}

export default function InvoiceAttachments(props: Props) {
  const { data, isLoading, isError, isSuccess } = useEmailAttachments(
    props.emailId,
  )

  if (isLoading) {
    return <p>Loading...</p>
  }

  if (isError) {
    return <p>Error</p>
  }

  return (
    <InnerWrapper>
      {props.invoiceUrl && (
        <>
          <WidgetHeader>
            <ContentTitle>Invoice</ContentTitle>
            <IconButton onClick={() => handleDownload(props.invoiceUrl)}>
              <DownloadIcon />
            </IconButton>
          </WidgetHeader>
          <PDFViewer
            url={props.invoiceUrl}
            renderPdfInline={props.renderInvoiceInline}
          />
        </>
      )}

      <WidgetHeader>
        <ContentTitle>Email copy</ContentTitle>
      </WidgetHeader>
      <EmailViewer
        dateLine={""}
        from={props.emailSender}
        to={""}
        cc={""}
        subject={props.emailSubject}
        body={props.emailBody}
      />
      {data && !!data.length && (
        <>
          <WidgetHeader>
            <ContentTitle>Attached files</ContentTitle>
          </WidgetHeader>
          <AttachmentWrapper>
            {data!.map((attachment) => (
              <Attachments
                key={attachment.gcs_location}
                fileName={attachment.original_attachment_name}
                signedUrl={attachment.gcs_location}
              />
            ))}
          </AttachmentWrapper>
        </>
      )}
    </InnerWrapper>
  )
}
